// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"0d59079a","453":"bcd93df1","623":"f1e840b8","744":"d98dd685","923":"ac4c8fa7"}[chunkId] + ".chunk.js";
};